import { render, staticRenderFns } from "./DynamicList.vue?vue&type=template&id=f2cb58b0&"
import script from "./DynamicList.vue?vue&type=script&lang=js&"
export * from "./DynamicList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f2cb58b0')) {
      api.createRecord('f2cb58b0', component.options)
    } else {
      api.reload('f2cb58b0', component.options)
    }
    module.hot.accept("./DynamicList.vue?vue&type=template&id=f2cb58b0&", function () {
      api.rerender('f2cb58b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/condoMngt/component/DynamicList.vue"
export default component.exports